import { useTranslation } from 'react-i18next';
import { SigninEmail } from '../signin-email';
import logo from '@/assets/selise-legal-logo.svg';
import { GoogleLoginButton } from '../google-login-button';
import { MicrosoftLoginButton } from '../microsoft-login-button';

import { Link } from 'react-router-dom';
import { AlertCircle, X } from 'lucide-react';
import { useAuthStore } from '@/state/store/auth';

export const Signin = () => {
  const { t } = useTranslation();
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const setSessionExpired = useAuthStore((s) => s.setSessionExpired);

  const isBannerAllowedToVisible = [
    'construct.seliseblocks.com',
    'stg-construct.seliseblocks.com',
    'dev-construct.seliseblocks.com',
  ].some((domain) => window.location.hostname === domain);
  
  return (
    <div className="flex flex-col gap-6">
      <div className="w-32 h-14 mb-2">
        <img src={logo} className="w-full h-full" alt="logo" />
      </div>
      {sessionExpired && (
        <div className="flex items-start gap-3 rounded-lg border border-destructive/20 bg-destructive/10 p-4">
          <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-destructive" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-destructive">{t('SESSION_EXPIRED_TITLE')}</p>
            <p className="mt-0.5 text-xs font-normal text-destructive/90">
              {t('SESSION_EXPIRED_DESCRIPTION')}
            </p>
          </div>
          <button
            type="button"
            aria-label={t('CLOSE')}
            onClick={() => setSessionExpired(false)}
            className="text-destructive/70 hover:text-destructive"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      )}
      <div>
        <div className="text-2xl font-bold text-high-emphasis">{t('LOG_IN')}</div>
        <div className="flex items-center gap-1 mt-1">
          <span className="text-sm font-normal text-medium-emphasis">
            {t('DONT_HAVE_ACCOUNT')}
          </span>
          <Link
            to={'/signup'}
            className="text-sm font-bold text-primary hover:text-primary-600 hover:underline"
          >
            {t('SIGN_UP')}
          </Link>
        </div>
      </div>
      <div className={'w-full ' + (isBannerAllowedToVisible ? 'visible' : 'invisible h-0')}>
        <div className="rounded-lg bg-success-background border border-success p-4">
          <p className="text-xs font-normal text-success-high-emphasis">
            Log in to explore the complete Demo and Documentation. Use the credentials:{' '}
            <span className="font-semibold">demo.construct@seliseblocks.com</span> with password:{' '}
            <span className="font-semibold">H%FE*FYi5oTQ!VyT6TkEy</span>
          </p>
        </div>
      </div>
      <div className="w-full flex flex-col gap-6">
        <SigninEmail />
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t border-muted" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-background px-2 text-muted-foreground">OR</span>
          </div>
        </div>
        <div className="flex justify-center gap-4">
          <GoogleLoginButton iconOnly />
          <MicrosoftLoginButton iconOnly />
        </div>
      </div>
    </div>
  );
};
